import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Booking } from './pages/Booking';
import { Stub } from './pages/Stub';
import { ServicesList } from './pages/ServicesList';
import { ServiceDetail } from './pages/ServiceDetail';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';
import { PatientInformation } from './pages/PatientInformation';
import { FAQ } from './pages/FAQ';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { About } from './pages/About';
import { BlogPost } from './pages/BlogPost';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2wjqhd6x524mn">
      <Layout data-id="element-1" data-mp="2wj8ehrfz0s5r">
        <Routes data-id="element-2" data-mp="2wip5x1c7ng4e">
          <Route path="/" element={<Home data-id="element-4" data-mp="28u5zysgmvffh" />} data-id="element-3" data-mp="2wi5n7ieqknpb" />
          <Route path="/book" element={<Booking data-id="element-6" data-mp="28suv0pbgc1ms" />} data-id="element-5" data-mp="28tmi1bqzgr1g" />

          {/* Fully built pages */}
          <Route path="/patient-information" element={<PatientInformation data-id="element-8" data-mp="23v2sz2h3ez4v" />} data-id="element-7" data-mp="23w4fq47h1a2f" />
          <Route path="/blog" element={<Blog data-id="element-10" data-mp="3iiwdijzxza14" />} data-id="element-9" data-mp="3ik7gihlkcdr6" />
          <Route path="/blog/:id" element={<BlogPost data-id="element-12" data-mp="3ii4qvyobommz" />} data-id="element-11" data-mp="3ijfw82xf22g7" />
          <Route path="/contact" element={<Contact data-id="element-14" data-mp="3mk85gw6ag7ch" />} data-id="element-13" data-mp="3ml13n8r6loj0" />
          <Route path="/services" element={<ServicesList data-id="element-16" data-mp="3rcj7q5oi4587" />} data-id="element-15" data-mp="3mjg9hk8s47lo" />
          <Route path="/services/:slug" element={<ServiceDetail data-id="element-18" data-mp="3recd7hndojem" />} data-id="element-17" data-mp="3rdaselgk8ijp" />
          <Route path="/faq" element={<FAQ data-id="element-20" data-mp="4wxfu7a14id" />} data-id="element-19" data-mp="5orv1p50w72" />
          <Route path="/privacy" element={<Privacy data-id="element-22" data-mp="7sxbo2oq39g" />} data-id="element-21" data-mp="5ghbgghm2z1" />
          <Route path="/terms" element={<Terms data-id="element-24" data-mp="2zmeo498kfm81" />} data-id="element-23" data-mp="2zlldgx6hkckm" />
          <Route path="/about" element={<About data-id="element-26" data-mp="33morde4z3yj7" />} data-id="element-25" data-mp="2zmwlj96ys6hj" />

          {/* Coming-soon pages */}
          <Route path="/doctors" element={<Stub data-id="element-28" data-mp="38lrp0dimj2h5" />} data-id="element-27" data-mp="33n6w6z5pbl2q" />
          <Route path="/facilities" element={<Stub data-id="element-30" data-mp="38l00tnrcw70w" />} data-id="element-29" data-mp="38l8gfnev5qfs" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}